import { PaintedScene } from '../PaintedScene';

export const FROST_BRIDGE_AFTERNOON_PHASER_KEY = 'FrostBridgeAfternoonScene' as const;
export const FROST_BRIDGE_AFTERNOON_MANIFEST_KEY = 's-302-frost-bridge-afternoon' as const;

export class FrostBridgeAfternoonScene extends PaintedScene {
  constructor() {
    super(FROST_BRIDGE_AFTERNOON_PHASER_KEY, FROST_BRIDGE_AFTERNOON_MANIFEST_KEY);
  }
}
